import React from "react";

// list box child component for personal detail
const SelectGovId = (props) => {
  const {  dataarr, name, onChange, value,widthValue } = props;
  return (
    <div>
      <select
        onChange={onChange}
        style={{ height: "40px", marginTop: "0.5rem", width: `${widthValue}` }}
        // onKeyPress={onKeyPress}
        name={name}
        id={name}
        value={value}
      >
           <option hidden value = "">Select a  Value</option>
        {  dataarr && dataarr.map((option) => {
          return (
         
            <option key={option.govtIdfName} value={option.govtIdfName}>
              {option.govtIdfName}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SelectGovId;
